import React from 'react'
import Gallerygrid from './Gallerygrid'

function About() {
  return (
    <div>
        <div className='-mt-12 sm:-mt-16 md:-mt-36 px-6 lg:px-24 lg:-mt-48 lg:mx-32 font-Questrial text-center'>
            <div className=' text-xl sm:text-4xl md:text-4xl px-6 text-blue-900 leading-tight font-extrabold tracking-wide'>
               About Sharyo
            </div>
            <div className='pt-4 font-medium tracking-wide'>
              SHARYO -- National Level Technical Symposium organized by the Department of Automobile Engineering from B.S.Abdur Rahman Crescent Institute of Science and Technology.
              The Symposium serves as a platform to showcase your perception, technical knowledge, creative thinking and helps in improving technical and rapport skills.
              </div>
        </div>
        <div className='px-6 lg:px-40 pt-10 pb-6 text-center font-Syncopate'>
        <div className='text-xl sm:text-4xl md:text-4xl px-6 text-blue-900 leading-tight font-extrabold'>
               Title Sponsor
            </div>
            <div className='pt-4 md:pt-2 flex items-center justify-center font-medium tracking-wide'>
            <img className='md:h-42 h-24  md:mt-6 rounded-lg md:w-42' src='/sponsor.png' alt='sponsor'/>
              </div>
        </div>
        <div className='px-6 lg:px-40 pt-10 pb-6 text-center font-Syncopate'>
        <div className='text-xl sm:text-4xl md:text-4xl px-6 text-blue-900 leading-tight font-extrabold'>
               Co-Sponsors
            </div>
        </div>
        <div className='pt-4 md:pt-2 lg:px-24'>
            <Gallerygrid/>
              </div>
        <div className='px-6 lg:px-40 pt-10 pb-6  text-center'>
            <div className='uppercase text-3xl sm:text-4xl md:text-4xl px-6 text-blue-900 font-Monoton leading-tight tracking-wider bg-gradient-to-r from-red-500 to-fuchsia-500 text-transparent bg-clip-text'>
               Giveaway
            </div>
            <div className='pt-2 font-medium tracking-wide'>
            <div className='grid grid-cols-1 md:grid-cols-2 px-2 mx-auto lg:px-20 my-2 md:gap-2 md:my-6'>
        <div className=' flex flex-col md:order-last text-center font-medium pb-8 md:pt-6 md:pb-0 items-center'>
        <p className='text-2xl font-Syncopate text-blue-500'>10K Worth Cash Prizes with Certificates</p>
          <p className='pt-2 font-Questrial tracking-widest'>Each Event ENTRY Rs.50</p>
        
<a href='https://docs.google.com/forms/d/e/1FAIpQLScRNoAdG_o6IJhSyPmPDS97z-3o6epEfF42_ynVNGvfEag_3A/viewform?usp=pp_url' target='_blank' rel='noreferrer' className="py-1 px-2 mt-2 font-Questrial text-sm font-medium text-center text-white bg-blue-700 rounded-lg focus:ring-4 focus:outline-none focus:ring-blue-300 ">
            Register here
            </a>
</div>
<img className='h-48 md:mt-2 rounded-lg w-full' src='/banner.png' alt="banner"/>
            </div>
              </div>
        </div>
    </div>
  )
}

export default About